import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonGroup } from 'react-bootstrap';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import _ from 'lodash';
const BackgroundElementFTs = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const { id, currentPage, params, attributes, setSelectedColor, blockContainerId, updateParam, settings, block, colorSettings, name: Tag, appIntl, updateBlocksState } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
    const [show, setShow] = useState(false);
    const [isEditorReady, setIsEditorReady] = useState(false);
    // Refs remember previous values
    const prevColorSettings = useRef(null);
    const prevParams = useRef(null);
    const changeBackgroundE = (bgColorE, blockId, dataNameE, initialUpdate) => {
        /* First, the color is set in the block using updateParams().
         * Then, the color is set as a "page", "section", or "stage" using setSelectedColor().
         */
        const metaTag = `<meta content="${bgColorE}" name="bgColorNew"/>`;
        updateParam(blockId, dataNameE, metaTag, null, '', '', currentPage, initialUpdate);
        let page = false, section = false, stage = false;
        if (attributes['data-backgrounds-tag']) {
            if (attributes['data-backgrounds-tag'].includes('section'))
                section = true;
            if (attributes['data-backgrounds-tag'].includes('page'))
                page = true;
            if (attributes['data-backgrounds-tag'].includes('stage'))
                stage = true;
        }
        if (setSelectedColor) {
            setSelectedColor(id, bgColorE, currentPage, '', section, page, blockContainerId, stage, attributes['data-name']);
        }
    };
    const updateAttributes = () => {
        const _attributes = _.cloneDeep(attributes);
        let valueOfColor = '';
        let contentValue = '';
        _.forEach(params, (param) => {
            if (param.name === attributes['data-name']) {
                valueOfColor = param === null || param === void 0 ? void 0 : param.value;
            }
        });
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = valueOfColor;
        const metaTag = tempDiv.querySelector(`meta[name="bgColorNew"]`);
        if (metaTag) {
            contentValue = metaTag.getAttribute('content') || '';
        }
        _attributes.className = [`${_attributes.className} ${contentValue}`].join(' ');
        return _attributes;
    };
    useEffect(() => {
        // Only on first mount → set initial color
        let contentValue;
        let valueOfColor = '';
        params.forEach((param) => {
            if (param.name === attributes['data-name']) {
                valueOfColor = param === null || param === void 0 ? void 0 : param.value;
            }
        });
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = valueOfColor;
        const metaTag = tempDiv.querySelector(`meta[name="bgColorNew"]`);
        if (metaTag) {
            contentValue = metaTag.getAttribute('content') || undefined;
        }
        if (attributes['data-backgrounds-init'] && contentValue === undefined) {
            changeBackgroundE(attributes['data-backgrounds-init'], id, attributes['data-name'], true);
        }
        // Only if colorSettings have really changed
        if (attributes['data-backgrounds-tag'] &&
            !show &&
            JSON.stringify(prevColorSettings.current) !== JSON.stringify(colorSettings) &&
            contentValue) {
            let page = false, section = false, stage = false;
            if (attributes['data-backgrounds-tag'].includes('section'))
                section = true;
            if (attributes['data-backgrounds-tag'].includes('page'))
                page = true;
            if (attributes['data-backgrounds-tag'].includes('stage'))
                stage = true;
            //
            if (setSelectedColor) {
                setSelectedColor(id, contentValue, currentPage, '', section, page, blockContainerId, stage, attributes['data-name']);
            }
        }
        // update previous values
        prevColorSettings.current = colorSettings;
        prevParams.current = params;
    }, []);
    const _attributes = updateAttributes();
    return (_jsx(Tag, Object.assign({}, _attributes, { contentEditable: false, children: _jsx(Fragment, { children: (block === null || block === void 0 ? void 0 : block.template) &&
                (block === null || block === void 0 ? void 0 : block.template.includes('data-backgrounds')) &&
                ((settings === null || settings === void 0 ? void 0 : settings.back_colors) || ((settings === null || settings === void 0 ? void 0 : settings.target) && ((_c = settings === null || settings === void 0 ? void 0 : settings.target) === null || _c === void 0 ? void 0 : _c.back_colors))) && (_jsxs("div", { "data-block": block === null || block === void 0 ? void 0 : block.id, "data-parent": block === null || block === void 0 ? void 0 : block.id, className: "toggle_bg colorButton btn-light", onClick: () => setShow((prev) => !prev), children: [_jsx("i", { className: "fas fa-fill-drip", "data-block": block === null || block === void 0 ? void 0 : block.id, "data-parent": block === null || block === void 0 ? void 0 : block.id }), show && (_jsxs(ButtonGroup, { className: "edit-color", vertical: true, children: [(_e = (_d = settings === null || settings === void 0 ? void 0 : settings.target) === null || _d === void 0 ? void 0 : _d.back_colors) === null || _e === void 0 ? void 0 : _e.map((bgColor) => {
                                var _a, _b;
                                const getBackgroundAttr = _attributes['data-backgrounds'];
                                if (getBackgroundAttr &&
                                    (getBackgroundAttr.includes((_a = bgColor === null || bgColor === void 0 ? void 0 : bgColor.label[0]) === null || _a === void 0 ? void 0 : _a.name) || getBackgroundAttr.includes('true'))) {
                                    return (_jsx(Button, { "data-tooltip-content": messages.editor.change_backgroundcolor, "data-tooltip-id": "blockinfo", "data-block": bgColor === null || bgColor === void 0 ? void 0 : bgColor.id, "data-parent": block === null || block === void 0 ? void 0 : block.id, onClick: () => { var _a; return changeBackgroundE((_a = bgColor === null || bgColor === void 0 ? void 0 : bgColor.label[0]) === null || _a === void 0 ? void 0 : _a.name, block.id, attributes['data-name']); }, style: { padding: 4 }, variant: "light", children: _jsx("p", { style: {
                                                width: 40,
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                background: bgColor.color,
                                            } }) }, 'target_bg_color_' + ((_b = bgColor === null || bgColor === void 0 ? void 0 : bgColor.label[0]) === null || _b === void 0 ? void 0 : _b.name)));
                                }
                                return null;
                            }), (_f = settings === null || settings === void 0 ? void 0 : settings.back_colors) === null || _f === void 0 ? void 0 : _f.map((bgColor) => {
                                const getBackgroundAttr = _attributes['data-backgrounds'];
                                if (getBackgroundAttr &&
                                    (getBackgroundAttr.includes(bgColor.label[0].name) || getBackgroundAttr.includes('true'))) {
                                    return (_jsx(Button, { "data-tooltip-content": messages.editor.change_backgroundcolor, "data-tooltip-id": "blockinfo", "data-block": bgColor === null || bgColor === void 0 ? void 0 : bgColor.id, "data-parent": block === null || block === void 0 ? void 0 : block.id, onClick: () => changeBackgroundE(bgColor === null || bgColor === void 0 ? void 0 : bgColor.label[0].name, block === null || block === void 0 ? void 0 : block.id, attributes['data-name']), style: { padding: 4 }, variant: "light", children: _jsx("p", { style: {
                                                width: 40,
                                                height: 40,
                                                padding: 0,
                                                margin: 0,
                                                background: bgColor === null || bgColor === void 0 ? void 0 : bgColor.color,
                                            } }) }, 'settings_bg_color_' + bgColor.label[0].name));
                                }
                                return null;
                            })] }))] })) }, 'bg_element_' + (block === null || block === void 0 ? void 0 : block.id)) })));
};
const mapStateToProps = (state) => {
    return {
        appIntl: state.intl,
    };
};
export default withRouter(connect(mapStateToProps)(legacyInjectIntl(BackgroundElementFTs)));
